import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    width={15.153}
    height="6.8mm"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 7879 13363"
    {...props}
  >
    <defs>
      <style>{".fil0{fill:#231f20}"}</style>
    </defs>
    <g id="Layer_x0020_1">
      <g id="_1974348099648">
        <path
          d="M0 0h7879v4631H0zM4515 5026H3260s380 4734-2384 7499h6023C4135 9760 4515 5026 4515 5026zM876 13026h6024v337H876z"
          className="fil0"
        />
      </g>
    </g>
  </svg>
)
export default SvgComponent
